var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-player player"},[_vm._v("\n    "+_vm._s(_vm.$t('player.not_supported'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }